var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.1877H3.375C3.22582 15.1877 3.08274 15.1284 2.97725 15.0229C2.87176 14.9174 2.8125 14.7743 2.8125 14.6252V11.4832C2.8125 11.4093 2.82705 11.3361 2.85532 11.2679C2.88359 11.1996 2.92502 11.1376 2.97725 11.0854L11.4148 2.64791C11.5202 2.54242 11.6633 2.48315 11.8125 2.48315C11.9617 2.48315 12.1048 2.54242 12.2102 2.64791L15.3523 5.78991C15.4577 5.8954 15.517 6.03848 15.517 6.18766C15.517 6.33684 15.4577 6.47992 15.3523 6.58541L6.75 15.1877ZM6.75 15.1877H15.1875M6.75 15.1877L2.84829 11.2859M9.5625 4.50016L13.5 8.43766",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilLine);
export default __webpack_public_path__ + "static/media/PencilLine.0a6db92d137dabd62a00a7ed1852de4f.svg";
export { ForwardRef as ReactComponent };